module.exports = __webpack_public_path__ + "510d0910b95536dd6ebbbfcc1e2239bd.svg";